import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import {
  FETCH_PRIZE,
  CREATE_PRIZE,
  UPDATE_PRIZE,
  FETCH_LUCKY_GAME_CONFIG,
} from '../actions/prize/action_types';
import actions from '../actions/prize';
import rf from '../../requests/RequestFactory';

function* fetchPrize(action) {
  try {
    const { data } = yield call(() => rf.getRequest('PrizeRequest').fetchPrize(), {});
    yield put(actions.fetchPrizeSucceed(data));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.fetchPrizeFailed(err));
  }
}

function* updatePrize(action) {
  try {
    const { data } = yield call((data) => rf.getRequest('PrizeRequest').updatePrize(data), action.data);
    yield put(actions.fetchPrize());
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.updatePrizeFailed(err));
  }
}

function* createPrize(action) {
  try {
    const { data } = yield call((data) => rf.getRequest('PrizeRequest').createPrize(data), action.data);
    yield put(actions.fetchPrize());
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.createPrizeFailed(err));
  }
}

function* fetchLuckyGameConfig(action) {
  try {
    const { data } = yield call(() => rf.getRequest('LuckyGameRequest').fetchConfig(), {});
    yield put(actions.fetchLuckyGameConfigSucceed(data));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.fetchLuckyGameConfigFailed(err));
  }
}

function* watchPrizes() {
  yield takeLatest(FETCH_PRIZE, fetchPrize);
  yield takeLatest(CREATE_PRIZE, createPrize);
  yield takeLatest(UPDATE_PRIZE, updatePrize);
  yield takeLatest(FETCH_LUCKY_GAME_CONFIG, fetchLuckyGameConfig);
}

export default function* rootSaga() {
  yield all([fork(watchPrizes)]);
}
